module.exports = __webpack_public_path__ + "static/pic03@4xwebp-179b5d7f0ef0f4d88d2f8e625c419727.webp";